import {Injectable} from "@angular/core";
import {ConstantService} from "./constant.service";
import {LocalStorage} from "./appstate/storage/local-storage";
import {CustomRouterService} from "./custom-router.service";
import {SessionStorage} from "./appstate/storage/session-storage";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {SocketService} from "./socket.service";
import {resetNavPermissionSync} from "../layout/nav-permission-sync.state";
import {AdminPermissionBootstrapService} from "./admin-permission-bootstrap.service";


@Injectable({
  providedIn: 'root'
})
export class GlobalAuthService {

  constructor(
    private readonly constantService: ConstantService,
    private readonly customRouterService: CustomRouterService,
    private readonly socketService: SocketService,
    private readonly httpClient: HttpClient,
    private readonly adminPermissionBootstrap: AdminPermissionBootstrapService,
  ) {
  }

  /**
   * Admin portal refresh: backend is POST /auth/v1/admins/refreshToken with refresh JWT in Authorization (express-jwt).
   */
  public refreshToken(payload: { refreshToken: string }): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${payload.refreshToken}`,
    });
    return this.httpClient.post(
      this.constantService.ADMIN_AUTH_ENDPOINT + 'refreshToken',
      {},
      {headers},
    );
  }

  signOut() {
    resetNavPermissionSync();
    this.adminPermissionBootstrap.clearSessionPermissions();
    LocalStorage.setPushNotifications([]);
    LocalStorage.resetLocal();
    SessionStorage.resetSession();
    this.socketService.disconnectAllSockets();
    this.customRouterService.goToPage('auth/login');
  }

}
